// extracted by mini-css-extract-plugin
module.exports =  {"shadow":"_93444fe79c--shadow--gHUci"};